var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import jwtDecode from 'jwt-decode';
import { routerActions, getLocation } from 'connected-react-router';
import * as queryString from 'query-string';
import { takeLatest, all, put, call, spawn, select, } from 'redux-saga/effects';
import { isTimeInPast } from '../utils/utils';
import { getClientId, getAuthSettings } from '../utils/selectors';
import { actions, ActionTypes } from './actions';
import { stringifyRoute, getWindowLocation } from './utils';
export function getAuthAndValidate() {
    var auth, isAuthValid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(getAuthFromUrl)];
            case 1:
                auth = _a.sent();
                if (!auth) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.redirectAfterLoginSuccess())];
            case 2:
                _a.sent();
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, call(getPersistedAuth)];
            case 4:
                auth = _a.sent();
                _a.label = 5;
            case 5: return [4 /*yield*/, call(validateAuth, auth)];
            case 6:
                isAuthValid = _a.sent();
                if (!isAuthValid) return [3 /*break*/, 8];
                return [4 /*yield*/, put(actions.validateAuthSuccess({ token: auth }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, put(actions.validateAuthFail())];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [2 /*return*/];
        }
    });
}
export function getAuthFromUrl() {
    var hash, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getLocation)];
            case 1:
                hash = (_a.sent()).hash;
                if (!hash) return [3 /*break*/, 3];
                return [4 /*yield*/, call(queryString.parse, hash)];
            case 2:
                token = (_a.sent()).access_token;
                return [2 /*return*/, token];
            case 3: return [2 /*return*/, null];
        }
    });
}
export function getPersistedAuth() {
    var storageKey, json, token;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)];
            case 1:
                storageKey = (_a.sent()).storageKey;
                return [4 /*yield*/, call([sessionStorage, sessionStorage.getItem], storageKey)];
            case 2:
                json = _a.sent();
                if (!json) return [3 /*break*/, 4];
                return [4 /*yield*/, call([JSON, JSON.parse], json)];
            case 3:
                token = (_a.sent()).token;
                return [2 /*return*/, token];
            case 4: return [2 /*return*/, undefined];
        }
    });
}
export function validateAuth(token) {
    var _a, aud, exp, roles, clientId, isExpired, e_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 4, , 5]);
                if (!token) {
                    return [2 /*return*/, false];
                }
                return [4 /*yield*/, call(jwtDecode, token)];
            case 1:
                _a = _b.sent(), aud = _a.aud, exp = _a.exp, roles = _a.roles;
                return [4 /*yield*/, select(getClientId)];
            case 2:
                clientId = _b.sent();
                return [4 /*yield*/, call(isTimeInPast, exp)];
            case 3:
                isExpired = _b.sent();
                if (aud !== clientId || isExpired) {
                    return [2 /*return*/, false];
                }
                if (!Array.isArray(roles) || roles.length === 0) {
                    return [2 /*return*/, false];
                }
                return [2 /*return*/, true];
            case 4:
                e_1 = _b.sent();
                return [2 /*return*/, false];
            case 5: return [2 /*return*/];
        }
    });
}
export function navigateToLogin() {
    var clientId, _a, loginUrl, scope, response_type, response_mode, _b, origin, pathname, search, redirectAfterLoginUrl, redirectToLoginUrl, windowLocation;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getClientId)];
            case 1:
                clientId = _c.sent();
                return [4 /*yield*/, select(getAuthSettings)];
            case 2:
                _a = _c.sent(), loginUrl = _a.loginUrl, scope = _a.scope, response_type = _a.response_type, response_mode = _a.response_mode;
                _b = window.location, origin = _b.origin, pathname = _b.pathname, search = _b.search;
                return [4 /*yield*/, call(stringifyRoute, origin + pathname, search)];
            case 3:
                redirectAfterLoginUrl = _c.sent();
                return [4 /*yield*/, call(stringifyRoute, loginUrl, {
                        scope: scope,
                        resource: clientId,
                        response_type: response_type,
                        response_mode: response_mode,
                        client_id: clientId,
                        nonce: Date.now(),
                        redirect_uri: redirectAfterLoginUrl,
                    })];
            case 4:
                redirectToLoginUrl = _c.sent();
                return [4 /*yield*/, call(getWindowLocation)];
            case 5:
                windowLocation = _c.sent();
                return [4 /*yield*/, call([windowLocation, windowLocation.replace], redirectToLoginUrl)];
            case 6:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export function clearAuthAndNavigateToLogin() {
    var storageKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)];
            case 1:
                storageKey = (_a.sent()).storageKey;
                return [4 /*yield*/, call([sessionStorage, sessionStorage.removeItem], storageKey)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(navigateToLogin)];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function persistAuth(_a) {
    var storageKey, stringifiedAuth;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getAuthSettings)];
            case 1:
                storageKey = (_b.sent()).storageKey;
                return [4 /*yield*/, call([JSON, JSON.stringify], {
                        token: payload.token,
                    })];
            case 2:
                stringifiedAuth = _b.sent();
                return [4 /*yield*/, call([sessionStorage, sessionStorage.setItem], storageKey, stringifiedAuth)];
            case 3:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
export function removeHashFromUrl() {
    var location;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getLocation)];
            case 1:
                location = _a.sent();
                return [4 /*yield*/, put(routerActions.replace(__assign(__assign({}, location), { hash: null })))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeLatest(ActionTypes.VALIDATE_AUTH_SUCCESS, persistAuth),
                    takeLatest(ActionTypes.VALIDATE_AUTH_FAIL, clearAuthAndNavigateToLogin),
                    takeLatest(ActionTypes.REDIRECT_AFTER_LOGIN_SUCCES, removeHashFromUrl),
                ])];
            case 1:
                _a.sent();
                return [4 /*yield*/, spawn(getAuthAndValidate)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
